import { defineComponent as _defineComponent } from 'vue'
import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "min-h-screen flex items-center justify-center p-4 sm:p-6" }
const _hoisted_2 = { class: "w-full max-w-md bg-white rounded-3xl shadow-2xl overflow-hidden" }

import { ref, computed } from "vue";
import { useRouter } from 'vue-router';

// Importar pasos
import StepEmailForm from "../components/ResetPassword/StepEmailForm.vue";
import StepCodeVerification from "../components/ResetPassword/StepCodeVerification.vue";
import StepNewPassword from "../components/ResetPassword/StepNewPassword.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'ResetPasswordView',
  setup(__props) {

const router = useRouter();

const currentStep = ref(1);
const email = ref("");
const token = ref("");
const isLoading = ref(false);

const currentComponent = computed(() => {
  switch (currentStep.value) {
    case 1:
      return StepEmailForm;
    case 2:
      return StepCodeVerification;
    case 3:
      return StepNewPassword;
    default:
      return StepEmailForm;
  }
});

function handleSendCode(newEmail: string) {
  email.value = newEmail;
  isLoading.value = true;
  setTimeout(() => {
    isLoading.value = false;
    currentStep.value = 2;
  }, 1200);
}

function handleVerifyCode(verifiedToken: string) {
  token.value = verifiedToken;
  isLoading.value = true;
  setTimeout(() => {
    isLoading.value = false;
    currentStep.value = 3;
  }, 1200);
}

function handleResendCode() {
  alert(`Código reenviado a ${email.value}`);
}

function handleResetSuccess() {
  isLoading.value = true;
  setTimeout(() => {
    isLoading.value = false;
    goToLogin();
  }, 1200);
}

function goToLogin() {
  currentStep.value = 1;
  email.value = "";
  token.value = "";
  router.push({ name: 'Login' });
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(), _createBlock(_resolveDynamicComponent(currentComponent.value), {
        email: email.value,
        token: token.value,
        "is-loading": isLoading.value,
        onSendCode: handleSendCode,
        onVerifyCode: handleVerifyCode,
        onResendCode: handleResendCode,
        onSuccess: handleResetSuccess
      }, null, 40, ["email", "token", "is-loading"]))
    ])
  ]))
}
}

})